import Swal from "sweetalert2";

/**
 * Shows a confirmation dialog. Returns a Promise that resolves to true if user confirms, false if cancelled.
 * @param {Object} options
 * @param {string} options.title - Dialog title
 * @param {string} options.text - Dialog message
 * @param {string} [options.confirmButtonText] - Confirm button label
 * @param {string} [options.cancelButtonText] - Cancel button label
 * @param {string} [options.icon='warning'] - Icon: 'warning' | 'question' | 'info' | 'error'
 * @returns {Promise<boolean>}
 */
export const deleteConfirmAlert = ({
    title = "Are you sure?",
    text = "You won't be able to revert this!",
    confirmButtonText = "Yes, delete it!",
    cancelButtonText = "No, cancel!",
    icon = "warning"
}) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText,
        cancelButtonText,
    }).then((result) => Boolean(result?.isConfirmed));
};
